import axios from "axios";

const backendUrl = process.env.REACT_APP_BACKEND_URL;
const cleanedBackendUrl = backendUrl.replace("/backend", "");

const RefundService = {
  getListRefund() {
    return axios.get(`${cleanedBackendUrl}/refund`);
  },
  processRefund(refundId, status, rejectReason) {
    return axios.post(
      `${cleanedBackendUrl}/refund/${refundId}/process`,
      {
        status: status,
        rejectReason: rejectReason
      }
    );
  },
  createRefundAdmin(orderId, username, paymentReferenceId, reason, accountNo, bankCode) {
    return axios.post(
      `${cleanedBackendUrl}/refund/admin`,
      {
        orderId: orderId,
        username: username,
        paymentReferenceId: paymentReferenceId,
        reason: reason,
        accountNumber: accountNo,
        bankCode: bankCode
      }
    )
  }
}

export default RefundService;